import { render, staticRenderFns } from "./CampaignDetails.vue?vue&type=template&id=0f50755e&scoped=true&"
import script from "./CampaignDetails.vue?vue&type=script&lang=js&"
export * from "./CampaignDetails.vue?vue&type=script&lang=js&"
import style0 from "./CampaignDetails.vue?vue&type=style&index=0&id=0f50755e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f50755e",
  null
  
)

export default component.exports